import { createPlayerTransactionRegistry } from 'entities/transaction';
import { playerPageTransactionsModel } from '../../model';
import cls from './player-page-transactions.module.scss';

const PlayerTransactionRegistry = createPlayerTransactionRegistry(
	playerPageTransactionsModel.playerTransactionRegistryModel,
	{ variant: 'compact' },
);

export const PlayerPageTransactions = () => (
	<PlayerTransactionRegistry
		withTitle={false}
		className={cls.playerPageTransactionsRegistry}
	/>
);
